<script setup lang="ts">
import { company } from '~/data/company'

const { t } = useI18n()
const crumbs = usePageMeta('contact')
useSchemaOrg([{ '@type': 'ContactPage', 'name': t('contact.title') }])
</script>

<template>
  <div>
    <PageHeader
      :title="t('contact.title')"
      :lead="t('contact.lead')"
      :crumbs="crumbs"
    />
    <div class="container-site section grid gap-16 pt-8 lg:grid-cols-[1fr_1.5fr]">
      <dl class="space-y-8">
        <div>
          <dt class="mb-1 flex items-center gap-2 font-semibold text-ink">
            <Icon
              name="i-lucide-phone"
              class="text-[1.25rem] text-brand-deep"
              aria-hidden="true"
            />{{ t('contact.phone') }}
          </dt>
          <dd>
            <a
              :href="company.telHref"
              class="link text-lg"
            >{{ company.phone }}</a>
          </dd>
        </div>
        <div>
          <dt class="mb-1 flex items-center gap-2 font-semibold text-ink">
            <Icon
              name="i-lucide-mail"
              class="text-[1.25rem] text-brand-deep"
              aria-hidden="true"
            />{{ t('contact.email') }}
          </dt>
          <dd>
            <a
              :href="`mailto:${company.email}`"
              class="link text-lg"
            >{{ company.email }}</a>
          </dd>
        </div>
        <div>
          <dt class="mb-1 flex items-center gap-2 font-semibold text-ink">
            <Icon
              name="i-lucide-map-pin"
              class="text-[1.25rem] text-brand-deep"
              aria-hidden="true"
            />{{ t('contact.address') }}
          </dt>
          <dd>
            <address class="not-italic">
              {{ company.name }}<br>{{ company.street }}<br>{{ company.zip }} {{ company.city }}
            </address>
          </dd>
        </div>
      </dl>
      <ContactForm />
    </div>
  </div>
</template>
